import { getMentionsPlugin } from 'hubspot-prosemirror/prosemirror/plugins/MentionsPlugin';
import { AT_MENTION } from 'hubspot-prosemirror/prosemirror/utils/mentionsUtil';
import { getMatchResults } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getOutOfOfficeAtMentionLabel } from 'routing-ui/working-hours/utils/outOfOfficeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function OwnersNotFound({
  text
}) {
  return /*#__PURE__*/_jsx("div", {
    "data-suggestion-item": "true",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.notFound",
      options: {
        search: text,
        uri: `/settings/${PortalIdParser.get()}/users/new`
      }
    })
  });
}
OwnersNotFound.displayName = 'OwnersNotFound';
function OwnersLoading() {
  return /*#__PURE__*/_jsx("div", {
    "data-suggestion-item": "true",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "composer-ui.prosemirror.plugins.mentions.resultsZeroStateLoading"
    })
  });
}
OwnersLoading.displayName = 'OwnersLoading';
function OwnersError() {
  return /*#__PURE__*/_jsx("div", {
    "data-suggestion-item": "true",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "composer-ui.prosemirror.plugins.mentions.resultsZeroStateError"
    })
  });
}
OwnersError.displayName = 'OwnersError';
const getNotFoundComponent = ({
  isLoading,
  isError
}) => {
  if (isLoading) {
    return OwnersLoading;
  } else if (isError) {
    return OwnersError;
  }
  return OwnersNotFound;
};
export const configureMentionsPlugin = ({
  users,
  isLoading,
  isError
}) => {
  const transformedOwners = users.map(user => {
    const outOfOfficeLabel = getOutOfOfficeAtMentionLabel(user.outOfOfficeHours);
    const text = outOfOfficeLabel ? `${user.text} ${outOfOfficeLabel}` : user.text;
    return {
      searchText: `${text} ${user.value}`,
      text,
      id: user.id
    };
  });
  const NotFoundComponent = getNotFoundComponent({
    isLoading,
    isError
  });
  const atMentionPlugin = getMentionsPlugin({
    getSuggestions: (text, done) => {
      done(getMatchResults(text, transformedOwners));
    },
    type: AT_MENTION,
    NotFoundComponent
  });
  return atMentionPlugin;
};